module.exports = __webpack_public_path__ + "static/media/19ESCAP34.c98e5f7e.jpg";